import { HeaderProperties } from '../../../../shared/uiComponents/Table/tableProperties';

export const programHeaders: HeaderProperties[] = [
	{ id: '5', name: 'Program name' },
	{ id: '1', name: 'Open targets' },
	{ id: '2', name: 'Mastered targets' },
	{ id: '3', name: 'Total targets' },
	{ id: '4', name: 'Actions' },
];
